<form
    #newTagForm="ngForm"
    *ngIf="!studyIdValue"
    [ngClass]="{ 'files-page-input-field': isFilesPage, 'MED-upload-modal-input-field': !isFilesPage, 'edit-tags-dialog-input-field': isEditTagsDialog }"
    (ngSubmit)="submitTag()"
    (keydown.enter)="submitTag()"
    class="d-flex align-items-center new-tag-form px-2"
>
    <div class="input-wrapper">
        <input
            #tagInput
            name="value"
            input-type="text"
            class="new-tag-input text-truncate me-2"
            [placeholder]="placeholder"
            [name]="name"
            [(ngModel)]="value"
            [ngModelOptions]="{ standalone: true }"
            (focus)="onInputFocus()"
            (blur)="onInputBlur()"
        />
    </div>

    <ca-icon *ngIf="showTagIcon && isTagIconShown()" name="tag" size="s" class="tag-icon"></ca-icon>
    <div class="d-flex confirm-tags" *ngIf="showIcons" tabindex="0">
        <button
            data-uit="create-tag-btn"
            type="submit"
            class="confirm d-flex align-items-center btn ca-btn-icon me-1"
            [ngbTooltip]="'UPLOAD_MED_FILES_DIALOG.BUTTONS.CONFIRM' | translate"
            #t="ngbTooltip"
        >
            <ca-icon name="checkmark" size="s"></ca-icon>
        </button>
        <button
            data-uit="cancel-tag-btn"
            type="button"
            class="decline d-flex align-items-center btn ca-btn-icon"
            (click)="resetTagInput()"
            [ngbTooltip]="'UPLOAD_MED_FILES_DIALOG.BUTTONS.CANCEL' | translate"
            #t="ngbTooltip"
            placement="top"
        >
            <ca-icon name="cross" size="s"></ca-icon>
        </button>
    </div>
</form>
